import React from 'react'
import styled from 'styled-components'
import { useControlValue } from '../../Contexts/ControlContext'
import { CurrentControls } from './CurrentControls'
import { InputRadio } from '../../Common/InputRadio'

export const Controls = () => {
	const { data, changeControl } = useControlValue()
	const controlTypes = ['company', 'employee info']

	return (
		<StyledControlsContainer>
			<StyledControls>
				{controlTypes.map(controlName => (
					<InputRadio
						label={controlName}
						name={controlName}
						checked={data.control}
						onChange={changeControl}
						key={controlName}
					/>
				))}
			</StyledControls>
			<CurrentControls />
		</StyledControlsContainer>
	)
}

const StyledControlsContainer = styled.article`
	grid-area: form;
	display: flex;
	flex-direction: column;
	padding: 2rem 2.5rem 2rem 2rem;
	color: #e8e8e8;
	background-color: #000;
	overflow-y: scroll;
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		width: 0;
		height: 0;
	}
`

const StyledControls = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 1rem;
	& > div {
		position: relative;
		flex: 1;
		text-align: center;
	}
	input[type='radio'] {
		position: absolute;
		top: auto;
		overflow: hidden;
		clip: rect(1px 1px 1px 1px);
		clip: rect(1px, 1px, 1px, 1px);
		width: 1px;
		height: 1px;
		white-space: nowrap;
		&:checked + label::before {
			transform: translateY(0);
			opacity: 1;
			transition: transform 0.1s ease-out;
		}
	}
	label {
		display: block;
		position: relative;
		padding: 0.5rem 0;
		transition: background-color 0.1s ease-in-out;
		user-select: none;
		text-transform: capitalize;
		&:hover {
			cursor: pointer;
		}
		&::before {
			content: '';
			position: absolute;
			left: 0;
			bottom: 0;
			transform: translateY(300%);
			width: 100%;
			height: 1px;
			background-color: #6a6a6a;
			opacity: 0;
			transition: opacity 0.2s ease-out, transform 0.2s ease-out;
		}
	}
`
